import React, { useEffect, useState, useContext } from 'react';
import { Row, Col } from 'reactstrap';
import FullLayout from '../layouts/FullLayout';
import { useNavigate } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Table from 'react-bootstrap/Table';
import axios from 'axios';
import "bootstrap/dist/css/bootstrap.min.css";
import { getAllCrud, deleteUser } from "../services/userServices";

import Toast from 'react-bootstrap/Toast';
import { RoleContext, AlertContext } from "../utils/contexts/RoleContext";
import Pagination from "../components/Pagination";
import { decidePages } from "../../src/utils/utils";

// const Users = ({ setJwtToken }) => {
const Users = () => {

    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [copy, setCopy] = useState([]);
    const [showDelete, setShowDelete] = useState(false);
    const [id, setId] = useState('');
    const [roleName, setRoleName] = useState('');

    const [pages, setPages] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);


    const toast = useContext(AlertContext);

    // useEffect(() => {
    //     setView(displayView);
    //   }, [displayView])
    //   const toast = useContext(AlertContext);
    useEffect(() => {
        fetchUsers(pageNumber);
    }, [pageNumber]);

    const fetchUsers = async (page) => {
        const token = localStorage.getItem('jwtToken');
        if (!token) {
            navigate(`/login`);
            return;
        }
        const pageCount = page != undefined ? page : 1;
        const response = await getAllCrud(pageCount);
        const responseData = response.data;
        let theme = "success"
        if (response.status == 200) {
            console.log('responseData..', responseData)
            setData(response.data.data || []);
            setCopy(response.data.data || []);
            // setPages(decidePages(responseData.totalPages)); // Dynamically set page numbers
            setPages(Array.from({ length: responseData.totalPages }, (_, i) => i + 1));

            // setPageNumber(responseData.currentPage);
        } else {
            theme = "danger"
        }
        window.scrollTo(0, 0);
        // toast.setToast(responseData.data, theme);

        // const pages = decidePages(response?.count);
        // setPages(pages);
        // setPageNumber(pageCount)
    }

    const handleDelete = async (id) => {
        try {
            const response = await deleteUser(id);

            const responseData = response?.data;
            let theme = "success";
            if (response?.status === 200) {
                fetchUsers(pageNumber);
                setShowDelete(false);  
            } else {
                console.log("error", response)
                theme = "danger"
            }
            window.scrollTo(0, 0);
            toast.setToast(responseData?.message, theme);
        } catch (error) {
            console.error("Error:", error);
        }

    };

    const handleEdit = (id) => {
        navigate(`/crud-details/${id}`);
    };

    const handleSearch = (e) => {
        const searchInput = e.target.value.toLowerCase();
        setData(copy.filter(item =>
            Object.values(item).some(val => String(val).toLowerCase().includes(searchInput))
        ));
    };


    return (
        <FullLayout>
            <Row>

                <div className="panel_top_section">
                    <h1>Users</h1>
                    <div className="grid_icons d-flex gap-3 align-items-center float-end">
                        <button type="button" className="btn_gradian" onClick={() => navigate('/crud-details')}>+ Add a User</button>
                        <div className="grid_list_icons d-flex align-items-center gap-2 nav nav-pills1" id="pills-tab" role="tablist">
                            {/* <span className="list_icons fs-2 nav-link active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true" ><i className="bi bi-list-ul"></i></span >
                        <span className="grid_icons fs-3 nav-link" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false"><i className="bi bi-grid-fill"></i></span> */}
                            {/* <span className="filter_icons fs-3"><i className="bi bi-funnel-fill"></i></span> */}
                        </div>

                    </div>
                </div>
                <Col className=''>
                    {/* --------------------------------------------------------------------------------*/}
                    {/* Card-1*/}
                    {/* --------------------------------------------------------------------------------*/}
                    <div className="tab-content" id="pills-tabContent ">

                        {/* list-tab */}
                        <div className="tab-pane fade show active " id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
                            <div className="row d-flex ">
                                <table>
                                    <tr className="list_head">
                                    <th>S No</th>

                                        <th>Name</th>
                                        {/* <th>Specialty</th> */}
                                        <th>Email</th>
                                        <th>Phone number</th>
                                        <th>USDT Balance</th>
                                        <th>CORSIA Balance</th>
                                        <th>Actions</th>
                                    </tr>
                                    {/* crud */}
                                        {data.length > 0 ? (
                                            data.map((eachItem, index) => {
                                                console.log('eachItem',eachItem)
                                               return (
                                                <tr key={eachItem.id} className="list_detail">
                                                    <td>{index + 1}</td>
                                                    <td>{eachItem.name}</td>
                                                    <td>{eachItem.email}</td>
                                                    <td>{eachItem.phone}</td>
                                                    
                                                    <td>{eachItem.balances ? eachItem.balances.USDTBalance : 0}</td>
                                                    <td>{eachItem.balances ? eachItem.balances.CORSIABalance : 0}</td>
                                                    <td>

                                                    <span className="action" >
                                                        <button className="edit_btn"
                                                            onClick={() => {
                                                                handleEdit(eachItem.id)
                                                               
                                                            }
                                                            }
                                                        ><i className="bi bi-pen"></i></button>
                                                        <button className="delete_btn_act"
                                                                onClick={() => { setShowDelete(true); setId(eachItem.id); }}
                                                        ><i className="bi bi-trash"></i></button>
                                                        <button className="delete_btn_act"
                                                            onClick={() => navigate(`/transaction-history/${eachItem.id}`,{ state: { userId: eachItem.id, userName: eachItem.name }})}
                                                        ><i className
                                                            ="bi bi-arrow-left-right"></i></button>
                                                        </span>

                                                    </td>
                                                </tr>
)})
                                        ) : (
                                            <tr>
                                                <td colSpan='5'>No Data Found</td>
                                            </tr>
                                        )}
                                    {/* crud */}

                                    {/* <tr className="list_detail pagination_list ">
                                        <td colspan="5">
                                            <ul>
                                                <li><a href="#"><i className="bi bi-arrow-left"></i></a></li>
                                                <li className="active"><a href="#">1</a></li>
                                                <li><a href="#">2</a></li>
                                                <li><a href="#">3</a></li>
                                                <li><a href="#">4</a></li>
                                                <li><a href="#">5</a></li>
                                                <li><a href="#"><i className="bi bi-arrow-right"></i></a></li>
                                            </ul>
                                        </td>
                                    </tr> */}
                                </table>








                            </div>
                        </div>
                    </div>
                    {pages.length > 1 &&
                        <div>
                            {pages.length > 1 && (
                                <Pagination
                                    pages={pages}
                                    currentPage={pageNumber}
                                    onClickPageNumber={(page) => {
                                        fetchUsers(page);  // Request the selected page
                                        setPageNumber(page);
                                    }}
                                />
                            )}

                        </div>
                    }
                </Col>
            </Row>
            {showDelete && (
                <Modal show={showDelete} onHide={() => setShowDelete(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>Delete Confirmation</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>Are you sure you want to delete this user?</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowDelete(false)}>Close</Button>
                        <Button variant="primary" onClick={() => handleDelete(id)}>Delete</Button>
                    </Modal.Footer>
                </Modal>
            )}


        </FullLayout>
    );
};

export default Users;